module.exports = __webpack_public_path__ + "img/chat-details1.e9596b90.png";